const init = () => {
    videoControlsInit();
    globalClickListener();
    window.resize(() => {
        mobileAccordion();
    });
    mobileAccordion();
    a11yFixes();
    // Initialize accordions
    initializeFAQAccordions();
};

const a11yFixes = () => {
    const links = document.querySelectorAll('a[target="_blank"]:not([aria-label*="new window"])');
    if (links) {
        links.forEach((link, ind) => {
            link.setAttribute('aria-label', `Open ${encodeURIComponent(link.textContent.trim())} in new window`);
        });
    }

    let fixCount = 0;
    let observer = null;
    
    const fixThirdPartyWidgets = () => {
        const buttons = document.querySelectorAll('.gw-tt-preview');
        
        if (buttons.length === 0) return;
        
        let allFixed = true;
        
        buttons.forEach(button => {
            const needsFix = !button.hasAttribute('aria-label') || 
                           button.querySelectorAll('svg:not([focusable="false"])').length > 0;
            
            if (needsFix) {
                allFixed = false;
            }
            
            const svgs = button.querySelectorAll('svg');
            svgs.forEach(svg => {
                svg.setAttribute('focusable', 'false');
                svg.setAttribute('aria-hidden', 'true');
            });
            
            const images = button.querySelectorAll('img[alt]');
            images.forEach(img => {
                if (img.alt.length > 100) {
                    img.setAttribute('aria-hidden', 'true');
                    img.alt = '';
                }
            });
            
            if (!button.hasAttribute('aria-label')) {
                button.setAttribute('aria-label', 'Preview video');
            }
        });
        
        fixCount++;
        
        if ((fixCount >= 3 && allFixed) || fixCount >= 5) {
            if (observer) {
                observer.disconnect();
                observer = null;
            }
        }
    };

    fixThirdPartyWidgets();

    const widgetContainer = document.querySelector('.gw-tt-gallery-widget');
    if (widgetContainer) {
        observer = new MutationObserver(() => {
            fixThirdPartyWidgets();
        });

        observer.observe(widgetContainer, { 
            childList: true, 
            subtree: true 
        });
    }
};

const mobileAccordion = () => {
    const isDesktop = window.screen.width >= 750;
    const specific = isDesktop ? ':not([open])' : '[open]';
    const mobileAccordions = document.querySelectorAll(`.mobile-accordion${specific}`);
    if (mobileAccordions.length) {
        mobileAccordions.forEach(el => {
            if (isDesktop) {
                el.setAttribute('open', '');
            }
            else {
                el.removeAttribute('open');
            }
        });
    }
};

const globalClickListener = () => {
    document.body.addEventListener('click', function (e) {
        const target = e.target;
        if (window.screen.width < 800) {
            if (target.classList.contains('footer-block__heading')) {
                const dropdownEl = target.closest('.footer-block-content');
                const isOpen = dropdownEl.classList.contains('open');
                if (isOpen) {
                    dropdownEl.classList.remove('open');
                } else {
                    dropdownEl.classList.add('open');
                }
            }
        }
        readMore(target, e);
        
        if (target.classList.contains('copy-link-btn') || target.closest('.copy-link-btn')) {
            e.preventDefault();
            copyPageLink();
        }
        
        if (target.classList.contains('email-share-btn') || target.closest('.email-share-btn')) {
            e.preventDefault();
            emailProductLink();
        }
    });
};

const readMore = (target, e) => {
    if (target.classList.contains('read-more')) {
        e.preventDefault();
        target.closest('.read-more-container').classList.add('expanded');
    }
    if (target.classList.contains('read-more-btn')) {
        e.preventDefault();
        const readMoreContainer = target.closest('.read-more-container');
        if (readMoreContainer.classList.contains('expanded')) {
            readMoreContainer.classList.remove('expanded');
        }
        else {
            readMoreContainer.classList.add('expanded');
        }
    }
};

const emailProductLink = () => {
    const currentUrl = window.location.href;
    const productTitle = document.querySelector('h1, .product-title, [data-product-title]')?.textContent?.trim() || 'Check out this product';
    
    const subject = encodeURIComponent(`${productTitle}`);
    const body = encodeURIComponent(`\n\n${productTitle}\n${currentUrl}\n\n`);
    
    const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
    
    try {
        window.location.href = mailtoLink;
    } catch (error) {
        console.error('Failed to open email client:', error);
        const emailContent = `Subject: ${productTitle} - ${shopName}\n\n${productTitle}\n${currentUrl}`;
        fallbackCopyToClipboard(emailContent);
        alert('Email client could not be opened. Email content copied to clipboard.');
    }
};

const copyPageLink = () => {
    const currentUrl = window.location.href;
    
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(currentUrl).then(() => {
            showCopySuccess();
        }).catch(() => {
            fallbackCopyToClipboard(currentUrl);
        });
    } else {
        fallbackCopyToClipboard(currentUrl);
    }
};

const fallbackCopyToClipboard = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
        document.execCommand('copy');
        if (text.includes('http')) {
            showCopySuccess();
        }
    } catch (err) {
        console.error('Failed to copy:', err);
    }
    
    document.body.removeChild(textArea);
};

const showCopySuccess = () => {
    const button = document.querySelector('.copy-link-btn');
    if (!button) return;
    
    const copyText = button.querySelector('.copy-link-text');
    const successText = button.querySelector('.copy-success-text');
    
    if (copyText && successText) {
        copyText.style.display = 'none';
        successText.style.display = 'inline';
        
        setTimeout(() => {
            copyText.style.display = 'inline';
            successText.style.display = 'none';
        }, 2000);
    }
};

const videoControlsInit = () => {
    let isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const videoToggles = [...document.querySelectorAll('.utility-btn')];
    if (videoToggles.length !== 0) {
        videoToggles.forEach((videoToggle) => {
            const video = videoToggle.parentElement.querySelector('video');
            if (!!video) {
                videoToggle.addEventListener('click', function (e) {
                    e.preventDefault();
                    const videoEl = this.parentElement.querySelector('video');
                    const videoPlay = videoEl.paused || videoEl.ended;
                    videoEl.controls = 0;
                    if (videoPlay) {
                        videoEl.play();
                        videoEl.classList.add('keep-playing');
                        videoEl.parentElement.classList.add('playing');
                        videoToggle.setAttribute('aria-label', 'pause video');
                        videoToggle.classList.add('active');
                    } else {
                        videoEl.pause();
                        videoEl.classList.remove('keep-playing');
                        videoEl.parentElement.classList.remove('playing');
                        videoToggle.setAttribute('aria-label', 'play video');
                        videoToggle.classList.remove('active');
                    }
                });
                video.classList.add('keep-playing');
                if (isMobileDevice) {
                    video.pause();
                    video.classList.remove('keep-playing');
                    video.parentElement.classList.remove('playing');
                    videoToggle.setAttribute('aria-label', 'play video');
                    videoToggle.classList.remove('active');
                }
            }
        });
        const videos = document.querySelectorAll('video');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const videoEl = entry.target;
                const isPlay = videoEl.paused && videoEl.classList.contains('keep-playing');
                const isPause = entry.intersectionRatio === 0 && !videoEl.paused;
                if (isPause) {
                    videoEl.pause();
                    videoEl.parentElement.classList.remove('playing');
                    let toggle = videoEl.parentElement.querySelector('.utility-btn');
                    toggle.setAttribute('aria-label', 'play video');
                    toggle.classList.remove('active');
                } else if (isPlay) {
                    videoEl.play();
                    videoEl.parentElement.classList.add('playing');
                    let toggle = videoEl.parentElement.querySelector('.utility-btn');
                    toggle.setAttribute('aria-label', 'pause video');
                    toggle.classList.add('active');
                }
            });
        });
        videos.forEach((video) => {
            observer.observe(video);
        });
    }
};

class SeparatedList extends HTMLElement {
    constructor() {
        super();
        const that = this;
        window.resize(() => {
            const items = that.querySelectorAll('li');
            items.forEach((item, itemIndex) => {
                const previousItem = items[itemIndex - 1];
                const nextItem = items[itemIndex + 1];
                item.classList.toggle('first-of-row', !previousItem || item.offsetTop !== previousItem.offsetTop);
                item.classList.toggle('last-of-row', !nextItem || item.offsetTop !== nextItem.offsetTop);
            });
        });
    }
}

const initializeFAQAccordions = () => {
    const faqSections = document.querySelectorAll('.faq-wrapper');
    
    if (faqSections.length === 0) {
        return;
    }

    faqSections.forEach((section, index) => {
        initializeFAQSection(section);
    });
};

const initializeFAQSection = (section) => {
    const faqAccordions = section.querySelectorAll('details[data-faq-id]');
    
    if (faqAccordions.length === 0) {
        return;
    }

    const singleOpenEnabled = section.dataset.singleOpen !== 'false';
    const openFirstEnabled = section.dataset.openFirst === 'true';

    faqAccordions.forEach((accordion, index) => {
        setupFAQAccordion(accordion, faqAccordions, singleOpenEnabled);
    });

    if (openFirstEnabled && faqAccordions.length > 0) {
        openFAQAccordion(faqAccordions[0]);
    }

    setupFAQResizeHandler(faqAccordions);
};

const setupFAQAccordion = (accordion, allAccordionsInSection, singleOpenEnabled) => {
    const summary = accordion.querySelector('summary');
    
    if (!summary) {
        return;
    }

    summary.addEventListener('click', (e) => {
        e.preventDefault();
        
        const isCurrentlyOpen = accordion.open;
        
        if (!isCurrentlyOpen) {
            if (singleOpenEnabled) {
                allAccordionsInSection.forEach((otherAccordion) => {
                    if (otherAccordion !== accordion && otherAccordion.open) {
                        closeFAQAccordion(otherAccordion);
                    }
                });
            }
            
            openFAQAccordion(accordion);
        } else {
            closeFAQAccordion(accordion);
        }
    });
};

const openFAQAccordion = (accordion) => {
    const content = accordion.querySelector('.faq-accordion__content');
    const icon = accordion.querySelector('.faq-accordion__toggle-icon');
    
    accordion.open = true;
    if (content) {
        content.classList.add('open');
    }
    if (icon) {
        icon.classList.add('open');
    }
};

const closeFAQAccordion = (accordion) => {
    const content = accordion.querySelector('.faq-accordion__content');
    const icon = accordion.querySelector('.faq-accordion__toggle-icon');
    
    if (content) {
        content.classList.remove('open');
    }
    if (icon) {
        icon.classList.remove('open');
    }
    
    setTimeout(() => {
        accordion.open = false;
    }, 400);
};

const setupFAQResizeHandler = (faqAccordions) => {
    let resizeTimeout;
    
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            faqAccordions.forEach((accordion) => {
                if (accordion.open) {
                    const content = accordion.querySelector('.faq-accordion__content');
                    if (content && content.classList.contains('open')) {
                        content.style.maxHeight = 'none';
                        setTimeout(() => {
                            content.style.maxHeight = '1000px';
                        }, 10);
                    }
                }
            });
        }, 150);
    });
};

customElements.define('separated-list', SeparatedList);

window.onload = () => {
    init();
};